import { isEoForm10SubTableData, isEoForm3SubTableData, isEoForm3TotalRow, isEoFormWithOrdinalNo, type EoForm, type EoForm10SubTableData, type EoForm3SubTableData, type EoForm6SubTableData } from '@/services/report/models/eoForm';

export function getPositionLabel(form: EoForm): string {
  const positionLabel = form.position;
  const ordinalNo = getEoFormOrdinalNo(form);

  return `${ordinalNo} ${positionLabel}`.trim();
}

export function getChildRowPositionLabel(
  parentRow: EoForm,
  row: EoForm3SubTableData | EoForm6SubTableData | EoForm10SubTableData
): string {
  const ordinalNo = getEoFormOrdinalNo(row as EoForm);
  if (isEoForm3SubTableData(row) || isEoForm10SubTableData(row)) {
    return `${ordinalNo} ${row.position}`.trim();
  }
  return `${ordinalNo} ${parentRow.position}`.trim();
}

function getEoFormOrdinalNo(row: EoForm): string {
  if (isEoFormWithOrdinalNo(row)) {
    return row.ordinalNo as string;
  }
  return '';
}

export function getEoFormPositionLabelForActivities(row: EoForm): string {
  if (isEoForm3TotalRow(row)) {
    return row.subTableData[0].position;
  }
  const positionLabel = row.position;
  const ordinalNo = getEoFormOrdinalNo(row);

  return `${ordinalNo} ${positionLabel}`.trim();
}
